import { isEmpty } from 'lodash-es';
import posthog from 'posthog-js/dist/module.slim';

import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';

import { POSTHOG_COOKIE_KEY } from '../constants';
import { transformVariantsPayloadToEventProperties } from './transform-variants-payload-to-event-properties';

export const getFeatureFlagsProperties = (stringifyValues = false): Record<string, unknown> => {
  // Get feature flags from PostHog client
  let featureFlagVariants = posthog.featureFlags?.getFlagVariants() ?? {};
  // As a fallback, get feature flags from cookies
  if (isEmpty(featureFlagVariants)) {
    const storedData = cookieStorage.getItem(POSTHOG_COOKIE_KEY);
    const cookiesProperties = JSON.parse(storedData || '{}');
    featureFlagVariants = cookiesProperties['featureFlags'] ?? {};
  }
  return transformVariantsPayloadToEventProperties(featureFlagVariants, stringifyValues);
};
